export const CHANNEL_ID = 'tuitui';
export const CHANNEL_NAME = 'TuiTui';
